var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFedexGround(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 782.09277,
    height: 314.85825,
    viewBox: "0 0 782.09277 314.85825",
    id: "svg3877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3879"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath378"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 308.602,262.903 91.059,0 0,54.213 -91.059,0 0,-54.213 z",
    id: "path380"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-382.79423,-227.36178)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(10.678011,0,0,-10.678011,-3045.0363,3480.893)",
    id: "g374"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath378)",
    id: "g376"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.553,287.037)",
    id: "g382"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,1.39 1.103,2.328 2.354,2.328 3.606,2.328 4.708,1.39 4.708,0 4.708,-1.39 3.606,-2.329 2.354,-2.329 1.103,-2.329 0,-1.39 0,0 m 2.366,0.263 c 0.401,0 0.514,0.214 0.514,0.401 0,0.225 -0.113,0.4 -0.514,0.4 l -0.511,0 0,-0.801 0.511,0 z m -0.511,-0.362 0,-1.278 -0.414,0 0,2.817 1.026,0 c 0.6,0 0.877,-0.263 0.877,-0.776 C 3.344,0.35 3.13,0.099 2.856,0.063 l 0,-0.012 C 3.092,0.013 3.18,-0.201 3.231,-0.589 3.269,-0.838 3.318,-1.277 3.407,-1.377 l -0.489,0 c -0.113,0.263 -0.1,0.638 -0.188,0.951 -0.074,0.238 -0.2,0.327 -0.475,0.327 l -0.4,0 z M 4.257,0 c 0,1.127 -0.8,1.953 -1.903,1.953 C 1.252,1.953 0.451,1.127 0.451,0 c 0,-1.127 0.801,-1.952 1.903,-1.952 1.103,0 1.903,0.825 1.903,1.952",
    id: "path384",
    style: {
      fill: "#40b93c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(381.397,285.1135)",
    id: "g386"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -2.714,3.044 -5.403,0 l -5.657,0 5.53,6.215 -5.53,6.215 5.834,0 2.74,-3.019 2.638,3.019 5.632,0 L 0.28,6.24 5.859,0 0,0 z",
    id: "path388",
    style: {
      fill: "#40b93c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(359.4679,285.1135)",
    id: "g390"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 0,19.58 10.868,0 0,-4.364 -6.264,0 0,-2.786 6.264,0 0,-4.2 -6.264,0 0,-3.854 6.264,0 L 10.868,0 0,0 z",
    id: "path392",
    style: {
      fill: "#40b93c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(352.1007,288.0945)",
    id: "g394"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.69,0 -2.741,1.575 -2.741,3.219 0,1.757 0.915,3.447 2.741,3.447 1.894,0 2.649,-1.69 2.649,-3.447 C 2.649,1.552 1.849,0 0,0 m -16.291,5.192 c 0.289,1.242 1.254,2.056 2.458,2.056 1.326,0 2.241,-0.789 2.482,-2.056 l -4.94,0 z M 2.782,16.6 l 0,-8.014 -0.05,0 c -1.015,1.167 -2.283,1.573 -3.754,1.573 -3.015,0 -5.285,-2.05 -6.082,-4.759 -0.909,2.985 -3.253,4.815 -6.729,4.815 -2.823,0 -5.051,-1.267 -6.215,-3.332 l 0,2.566 -5.834,0 0,2.786 6.367,0 0,4.365 -11.568,0 0,-19.581 5.201,0 0,8.231 5.184,0 c -0.155,-0.605 -0.238,-1.253 -0.238,-1.935 0,-4.085 3.121,-6.951 7.103,-6.951 3.349,0 5.556,1.572 6.722,4.438 l -4.456,0 c -0.604,-0.861 -1.061,-1.117 -2.266,-1.117 -1.398,0 -2.603,1.219 -2.603,2.666 l 9.076,0 c 0.394,-3.245 2.921,-6.043 6.388,-6.043 1.496,0 2.867,0.736 3.704,1.979 l 0.05,0 0,-1.268 4.585,0 0,19.581 -4.585,0 z",
    id: "path396",
    style: {
      fill: "#412c91",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(362.3016,275.7312)",
    id: "g398"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.592,0 1.056,0.087 1.513,0.243 l 0,2.276 -1.716,0 0,0.523 2.355,0 0,-3.178 c -0.736,-0.232 -1.308,-0.387 -2.171,-0.387 -2.132,0 -3.304,1.647 -3.304,3.623 0,1.978 0.921,3.625 3.052,3.625 1.153,0 2.084,-0.611 2.335,-1.686 l -0.697,0 C 1.222,5.785 0.456,6.201 -0.251,6.201 -2.006,6.201 -2.654,4.603 -2.654,3.1 -2.654,1.598 -1.754,0 0,0",
    id: "path400",
    style: {
      fill: "#412c91",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(367.6401,279.7723)",
    id: "g402"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.978,0 -1.317,-0.824 -1.317,-1.677 l 0,-2.772 -0.591,0 0,3.459 c 0,0.476 -0.01,0.961 -0.029,1.444 l 0.58,0 0.04,-0.706 c 0.29,0.562 0.774,0.823 1.424,0.823 0.087,0 0.184,-0.01 0.271,-0.019 l 0,-0.592 C 0.243,-0.02 0.136,0 0,0",
    id: "path404",
    style: {
      fill: "#412c91",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(370.542,275.6539)",
    id: "g406"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 1.172,0 1.667,1.065 1.667,2.122 1.667,3.178 1.172,4.244 0,4.244 -1.173,4.244 -1.667,3.178 -1.667,2.122 -1.667,1.065 -1.173,0 0,0 m 0,-0.445 c -1.493,0 -2.296,1.152 -2.296,2.567 0,1.414 0.803,2.568 2.296,2.568 1.491,0 2.296,-1.154 2.296,-2.568 C 2.296,0.707 1.491,-0.445 0,-0.445",
    id: "path408",
    style: {
      fill: "#412c91",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(377.363,275.3232)",
    id: "g410"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -0.019,0.737 c -0.339,-0.571 -0.873,-0.852 -1.589,-0.852 -1.308,0 -1.745,0.717 -1.745,1.948 l 0,3.071 0.591,0 0,-2.84 c 0,-0.91 0.214,-1.686 1.25,-1.686 1.106,0 1.474,0.979 1.474,1.949 l 0,2.577 0.592,0 0,-3.439 C 0.554,0.979 0.562,0.485 0.582,0 L 0,0 z",
    id: "path412",
    style: {
      fill: "#412c91",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(379.8265,280.227)",
    id: "g414"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 0.019,-0.737 c 0.339,0.572 0.872,0.854 1.589,0.854 1.308,0 1.744,-0.718 1.744,-1.948 l 0,-3.073 -0.59,0 0,2.84 c 0,0.91 -0.214,1.687 -1.25,1.687 -1.106,0 -1.473,-0.98 -1.473,-1.948 l 0,-2.579 -0.592,0 0,3.441 c 0,0.485 -0.009,0.979 -0.029,1.463 L 0,0 z",
    id: "path416",
    style: {
      fill: "#412c91",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(384.9781,277.7759)",
    id: "g418"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,-1.048 0.435,-2.075 1.598,-2.075 2.694,-2.075 3.09,-1.173 3.09,0 3.09,1.171 2.694,2.074 1.598,2.074 0.435,2.074 0,1.046 0,0 m 3.09,4.564 0.592,0 0,-5.552 c 0,-0.486 0,-0.98 0.028,-1.465 l -0.581,0 -0.018,0.737 c -0.369,-0.58 -0.854,-0.852 -1.58,-0.852 -1.512,0 -2.162,1.249 -2.162,2.568 0,1.317 0.65,2.568 2.162,2.568 0.677,0 1.211,-0.262 1.559,-0.824 l 0,2.82 z",
    id: "path420",
    style: {
      fill: "#412c91",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFedexGround);
export default __webpack_public_path__ + "static/media/fedex-ground.2f3608c393fbd45db6c60cde8167ce07.svg";
export { ForwardRef as ReactComponent };